import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './Section';
import './Skills.css';

export function Skills({ items }) {
  return (
    <Section id="skills" title="Skills">
      <div className="skills-grid">
        {items.map((skillGroup, idx) => (
          <motion.div
            key={skillGroup.category}
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            viewport={{ once: true, margin: '-100px' }}
            className="skill-group"
          >
            <h4 className="skill-category">{skillGroup.category}</h4>
            <div className="skill-items">
              {skillGroup.items.map((skill) => (
                <span key={skill} className="skill-item">{skill}</span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
